import { useGetOne } from 'react-admin';
import { stringify } from 'query-string';

export function useWellnessPlans({ state, species, age, zipcode, enabled = true }) {
  return useGetOne(
    'wellness-quotes',
    {
      id: `plans?${stringify({ state, species, age, zipcode })}`,
    },
    {
      enabled: enabled && !!state && !!species && !!age && !!zipcode,
      select: response => response?.options || {},
    }
  );
}
